import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BDFlag from "../../../assets/icons/BDFlag";
import FileIcon from "../../../assets/icons/FileIcon";
import {
  useGetEmployeeDetailsQuery,
  useUpdateEmployeeEmergencyContactMutation,
} from "../../../features/employee/employeeApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import InfoTitle from "../../common/InfoTitle";
import Loader from "../../ui/Loader";
import { replaceEditWithView } from "./utils";

export default function EmergencyInfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const { editId } = useParams();
  const {
    isLoading: isGetDetailsLoading,
    isError: isGetEmployeeDetailsError,
    error: getEmployeeDetailsError,
    data: getEmployeeData,
  } = useGetEmployeeDetailsQuery(editId || "", {
    skip: !editId,
  });
  const [
    updateEmployeeEmergencyContact,
    { isLoading, isError, error, isSuccess },
  ] = useUpdateEmployeeEmergencyContactMutation();
  useError(
    isGetEmployeeDetailsError,
    getEmployeeDetailsError,
    "Get employee data fail"
  );
  useError(isError, error, "Update emergency contact fail");

  const onFinish = (values: any) => {
    const newData = {
      ...values,
      member_id: getEmployeeData?.data?.employee?.member_id,
    };

    if (editId)
      updateEmployeeEmergencyContact({
        body: newData,
        id: editId,
      });
  };

  useEffect(() => {
    if (Object.keys(getEmployeeData?.data?.employee || {})) {
      const employee = getEmployeeData?.data?.employee;

      form.setFieldsValue({
        emergency_contract_person_name:
          employee?.member?.emergency_contract_person_name,
        emergency_contract_person_number:
          employee?.member?.emergency_contract_person_number,
        emergency_contract_person_relationship:
          employee?.member?.emergency_contract_person_relationship,
      });
    }
  }, [form, getEmployeeData?.data?.employee]);

  const backLink = replaceEditWithView(location.pathname + location.search);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Emergency contact  updated successfully!");
      navigate(backLink);
    }
  }, [backLink, isSuccess, navigate]);

  return (
    <div>
      <InfoTitle className="mb-6" icon={<FileIcon />}>
        Emergency Information
      </InfoTitle>
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        {isGetDetailsLoading ? (
          <Loader />
        ) : (
          <>
            <Form.Item
              name="emergency_contract_person_name"
              label="Full Name"
              className="mb-4"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter name",
              //   },
              // ]}
            >
              <Input
                size="large"
                //  placeholder="Enter your name"
                disabled
              />
            </Form.Item>
            <Form.Item
              name="emergency_contract_person_number"
              label="Contact Number"
              className="mb-1"
              initialValue="+880"
              rules={[
                {
                  validator: async (_: any, value: string) => {
                    if (!value) {
                      return Promise.resolve();
                    }
                    // if (!value) {
                    //   return Promise.reject(
                    //     new Error("Please enter phone number")
                    //   );
                    // }

                    const phoneRegex = /^(\+88)?(01[3-9])[0-9]{8}$/;
                    if (!phoneRegex.test(value)) {
                      return Promise.reject(
                        new Error(
                          "Please enter a valid Bangladeshi phone number"
                        )
                      );
                    }
                  },
                },
              ]}
            >
              <Input
                prefix={<BDFlag />}
                size="large"
                // placeholder="+8801"
                disabled
              />
            </Form.Item>
            <Form.Item
              name="emergency_contract_person_relationship"
              label="Relationship"
              className="mb-4"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter relationship",
              //   },
              // ]}
            >
              <Input
                size="large"
                // placeholder="Enter your relationship"
                disabled
              />
            </Form.Item>
          </>
        )}

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={() => navigate(backLink)}
            size="middle"
            disabled={isLoading}
          >
            Cancel
          </Button>
          {/* <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Update
          </Button> */}
        </Space>
      </Form>
    </div>
  );
}
